import SignUpHeader from "./SignUpHeader";

export default SignUpHeader;